import React, {useEffect, useState} from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ModalOp = ({name, id, domain}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [list, setList] = useState([]) //["dad", "mom", "dad", "mom", "dad", "mom","dad", "mom","dad", "mom","dad", "mom","dad", "mom", "dad", "mom","dad", "mom","dad", "mom"]
  const fetchProgs = async () => {
    try{
      const responce = await fetch(`https://${domain}/api/packages/progs/${id}`)
      if(!responce.ok) throw new Error(responce.message);
      const data = await responce.json();
      setList(data.progs || []);
    }catch(e){ console.error(e); }
  }

  useEffect(() => {
    fetchProgs()
  }, [open])

  return (
    <div key={id}>
      <button className='transp-btn' onClick={handleOpen}>{name}</button>
      {open &&         
        <div className='modal-window'>
              <div className='modal-box programs'>
                <h2>List of programs</h2>
                <h3 style={{textAlign: 'center', color: "#1565C0"}}>{name}</h3>
                <ul>{list.map(program => <li>{program}</li>)}</ul>
                
              </div>
              <button className='requestBtn' onClick={handleClose}>Close</button>
        </div>
      }
    </div>
  );
}

export default ModalOp